module.exports = __webpack_public_path__ + "img/Journalism.e8274ec6.png";